import { useTranslation } from "react-i18next";

export const OnairFallbackMessage = () => {
  const { t } = useTranslation();
  return <span>{t("no_on_air")}</span>;
};
